import { Page } from '@progress/kendo-react-dropdowns';
import { Grid, GridPageChangeEvent, GridProps } from '@progress/kendo-react-grid';
import { PropsWithChildren, useState } from 'react';

interface Props extends GridProps {
  pageSize?: number,
  data: any[],
}

const PagedGrid = ({ pageSize = 20, data, children, ...others }: PropsWithChildren<Props>) => {
  const[{ skip, take }, setPage] = useState<Page>({ skip: 0, take: pageSize });
  
  const pageStart = skip;
  const pageEnd = skip + take;

  const gridData = data?.slice(pageStart, pageEnd) || [];

  const handlePageChange = ({ page }: GridPageChangeEvent) => {
    setPage(page);
  };

  return (
    <Grid
      data={gridData}
      pageable={true}
      skip={skip}
      take={take}
      total={data.length}
      onPageChange={handlePageChange}
      {...others}
    >
      {children}
    </Grid>
  );
};

export default PagedGrid;
